export enum pages {
    HOME = "/",
    ERROR = "/error",
    SURVEY = "/survey",
    THANKS = "/thanks",
}
